module.exports = __webpack_public_path__ + "img/数字货币.a5ffcf02.png";